"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorTokenToHex = void 0;
// @ts-nocheck
var js_object_1 = require("../../js-object");
var applyModifier = function (c, modifier, step) {
    switch (modifier) {
        case 'shade':
            return c.shade[step];
        case 'tint':
        default:
            return c.tint[step];
    }
};
/**
 * Converts a color string like `blue-tint-80` into a hex value.
 * Does not throw errors for unaccepted values, instead returns undefined.
 * @returns A hex code, otherwise undefined (if the color is not supported).
 */
var colorTokenToHex = function (colorString) {
    var _a, _b;
    var regex = /(brand-(primary|secondary)|\w+)(?:-(tint|shade)-(\d+))?/;
    var match = regex.exec(colorString);
    if (!match)
        return undefined;
    var _c = match, color = _c[1], colorInstance = _c[2], modifier = _c[3], step = _c[4];
    switch (color) {
        case 'black':
        case 'white':
            return js_object_1.color.contrast[color];
        case 'danger':
        case 'attention':
        case 'success':
        case 'interaction':
        case 'neutral':
        case 'muted':
        case 'focused':
        case 'disabled':
        case 'inverted':
        case 'appBackground':
            return js_object_1.color[color];
        case 'brand-primary':
        case 'brand-secondary':
            if (!colorInstance)
                return undefined;
            return modifier && step
                ? applyModifier(js_object_1.color.brand[colorInstance], modifier, step)
                : (_a = js_object_1.color.brand[colorInstance]) === null || _a === void 0 ? void 0 : _a.default;
        default:
            return modifier && step
                ? applyModifier(js_object_1.color.palette[color], modifier, step)
                : (_b = js_object_1.color.palette[color]) === null || _b === void 0 ? void 0 : _b.default;
    }
};
exports.colorTokenToHex = colorTokenToHex;
//# sourceMappingURL=colorTokenToHex.js.map